module.exports = __webpack_public_path__ + "static/img/IMG_20160925_192703.d7f50896.jpg";